
export class FinalAmadeusParsedData {
  availabilityType: string = '';
  originDestinations: any[] = [];
  airlinePreference: any[] = [];
  cabinTypes: any[] = [];
  classOfBooking: any[] = [];
  flightNumbers: string[] = [];
}
